import type { Theme } from '../../themes/themes';

export const createToggleSwitchTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 32,
          height: 18,
          padding: 0,
          overflow: 'visible',
          [theme.breakpoints.up('lg')]: {
            width: 42,
            height: 24,
            padding: 0,
          },
          '&:has(.Mui-focusVisible)': {
            outline: `2px solid ${theme.palette.border.defaultFocus}`,
            outlineOffset: 2,
            borderRadius: 15,
          },
        },

        track: {
          backgroundColor: theme.palette.surface.indeterminate,
          borderRadius: 15,
          opacity: 1,
          outline: '2px solid transparent',
          '&:focus-visible': {
            borderLeftWidth: '1px',
            borderRightWidth: '1px',
            boxShadow: '0 0 0 2px #FFF',
            outline: `2px solid ${theme.palette.border.defaultFocus}`,
            outlineOffset: '2px',
          },
        },

        thumb: {
          color: theme.palette.background.default,
          backgroundColor: 'currentColor',
          boxShadow: 'none',
          width: 14,
          height: 14,
          [theme.breakpoints.up('lg')]: {
            width: 20,
            height: 20,
          },
        },

        switchBase: {
          padding: 2,

          '&.Mui-checked .MuiSwitch-thumb': {
            position: 'relative',
            right: 6,
            [theme.breakpoints.up('lg')]: {
              right: 2,
            },
          },

          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: theme.palette.surface.positive,
            opacity: 1,
          },

          '&:hover::before': {
            border: '8px solid transparent',
            borderRadius: '50%',
            borderColor: theme.palette.surface.indeterminate,
            opacity: 0.1,
            content: '""',
            position: 'absolute',
            inset: -6,
          },

          '&:hover.Mui-checked::before': {
            borderColor: theme.palette.surface.positive,
            top: -6,
            right: 0,
            bottom: -6,
            left: -12,
            [theme.breakpoints.up('lg')]: {
              inset: -6,
            },
          },

          '&:hover.MuiSwitch-switchBase': {
            backgroundColor: 'transparent',
          },

          '&:active::before': {
            opacity: 0.2,
          },

          '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: theme.palette.background.defaultDisabled,
            opacity: 1,
          },
        },
      },
    },
  },
});
